var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOcrDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ocr-document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1006 5.40015V13.5001C17.1006 14.9913 18.3094 16.2001 19.8006 16.2001H27.9006V27.9001C27.9006 29.3913 26.6918 30.6001 25.2006 30.6001H10.8006C9.30942 30.6001 8.10059 29.3913 8.10059 27.9001V8.10015C8.10059 6.60898 9.30942 5.40015 10.8006 5.40015H17.1006Z",
    fill: "#ADCCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9006 5.85015V13.5001C18.9006 13.9972 19.3035 14.4001 19.8006 14.4001H27.4506L18.9006 5.85015Z",
    fill: "#ADCCF3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H7.5C8.32843 0 9 0.671573 9 1.5C9 2.32843 8.32843 3 7.5 3H3V7.5C3 8.32843 2.32843 9 1.5 9C0.671573 9 0 8.32843 0 7.5V1.5ZM0 34.5C0 35.3284 0.671573 36 1.5 36H7.5C8.32843 36 9 35.3284 9 34.5C9 33.6716 8.32843 33 7.5 33H3V28.5C3 27.6716 2.32843 27 1.5 27C0.671573 27 0 27.6716 0 28.5V34.5ZM34.5 0C35.3284 0 36 0.671573 36 1.5V7.5C36 8.32843 35.3284 9 34.5 9C33.6716 9 33 8.32843 33 7.5V3H28.5C27.6716 3 27 2.32843 27 1.5C27 0.671573 27.6716 0 28.5 0H34.5ZM36 34.5C36 35.3284 35.3284 36 34.5 36H28.5C27.6716 36 27 35.3284 27 34.5C27 33.6716 27.6716 33 28.5 33H33V28.5C33 27.6716 33.6716 27 34.5 27C35.3284 27 36 27.6716 36 28.5V34.5ZM6 19.5C5.17157 19.5 4.5 20.1716 4.5 21C4.5 21.8284 5.17157 22.5 6 22.5H30C30.8284 22.5 31.5 21.8284 31.5 21C31.5 20.1716 30.8284 19.5 30 19.5H6Z",
    fill: "#1C3D61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrDocument);
export default __webpack_public_path__ + "static/media/ocr-document.0b0c6a0d30dd1ef462f9f2952ec259e6.svg";
export { ForwardRef as ReactComponent };